/**
 * Codes hreflang annoncés pour chaque langue du site — SOURCE UNIQUE des
 * balises de la page (app/plugins/hreflang.ts) et du plan du site
 * (server/plugins/sitemap-langues.ts).
 *
 * Analyse GEO du 01/11/2026 : les deux se contredisaient. Les pages
 * annonçaient « fr, fr-BE, fr-LU… » et « en, de, nl », le plan du site
 * « fr-FR, en-GB, de-DE, nl-NL » — soit, pour Google, des pages réservées à
 * la France, au Royaume-Uni, à l'Allemagne et aux Pays-Bas, alors que les
 * associations visées sont aussi belges et luxembourgeoises.
 *
 * Règle : chaque langue est annoncée par son code seul (« nl » = tous les
 * néerlandophones), plus les variantes des pays où Donoor est ouvert et où
 * l'on parle cette langue (Belgique : fr, nl, de ; Luxembourg : fr, de ;
 * Pays-Bas : nl, depuis le 01/11/2026 ; Allemagne : de, depuis le
 * 03/11/2026). Les variantes francophones historiques (Suisse, Canada)
 * restent.
 */
export const VARIANTES_HREFLANG: Readonly<Record<string, readonly string[]>> = {
  fr: ["fr", "fr-FR", "fr-BE", "fr-CH", "fr-CA", "fr-LU"],
  en: ["en"],
  de: ["de", "de-DE", "de-BE", "de-LU"],
  es: ["es"],
  it: ["it"],
  nl: ["nl", "nl-NL", "nl-BE"],
};

/** Codes hreflang d'une langue du site (langue inconnue : son code seul). */
export function codesHreflang(langue: string): readonly string[] {
  return VARIANTES_HREFLANG[langue] ?? [langue];
}
